<template>
  <component :is="sprite" :style="{ color }" />
</template>

<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps({
  spriteId: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: ''
  }
})

const sprite = defineAsyncComponent(async () => import(`./svg/${props.spriteId}.vue`))
</script>
